export class SubscriptionEnrollDto {
    constructor(public userCode: string,
                public planCode: string,
                public duration: number,
                public notes: string) {
    }
}
